module.exports = __webpack_public_path__ + "img/arrow_from.38264d06.svg";